import { registerSW } from 'virtual:pwa-register';

/** Service-Worker-Registrierung; hält die installierte App ohne Nachfrage aktuell. */
export function registerServiceWorker(): void {
  registerSW({ immediate: true });
}
